import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_AD_UNIT: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteAdUnit($input: DeleteAdUnitInput!) {
    deleteAdUnit(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
